import { ArrowLeft } from "@phosphor-icons/react"
import { t } from "i18next"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu.tsx"

type phoneNumberList = {
  phoneNumber: string
  label: string
}
interface ExistingPhoneNumberListProps {
  onSelect: (phoneNumber: string) => void
  phoneNumberList: phoneNumberList[]
}

const ExistingPhoneNumberList = ({ onSelect, phoneNumberList }: ExistingPhoneNumberListProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild data-testid="show-existing-phone-number-button">
        <div className="hover:bg-surface-hovered cursor-pointer rounded-lg p-2">
          <ArrowLeft />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        side="bottom"
        data-testid="language-filter-content"
        className="z-1000 grid min-w-37.5 gap-2 rounded-md border-none p-2 leading-5">
        <DropdownMenuLabel>{t("patient.phoneNumber.useExisting")}</DropdownMenuLabel>
        {phoneNumberList.map((data) => (
          <DropdownMenuCheckboxItem
            key={1}
            onCheckedChange={() => onSelect(data.phoneNumber)}
            data-testid="existing-phone-number">
            <div className="flex-col">
              <div className="text-body-sm">{data.phoneNumber}</div>
              <div className="text-body-sm">{data.label}</div>
            </div>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { ExistingPhoneNumberList }
